/** NEW1 « + » menu: visible copy only. */
export const NEW_MENU_COPY = Object.freeze({
  title: 'Nouveau',
  railLabel: 'Ajouter',
  loading: 'Chargement…',
  lesson: 'Nouveau cours',
  lessonHint: 'Démarrer une séance',
  lessonPrompt: 'Pour quel élève ?',
  suggested: (count) => (count > 1 ? `${count} élèves suggérés` : `${count} élève suggéré`),
  otherStudent: 'Autre élève',
  newStudent: 'Nouvel élève',
  newStudentHint: 'Ajouter à une famille',
  newStudentPrompt: 'Dans quelle famille ?',
  family: (name) => `Famille ${name}`,
  newestFamily: 'la plus récente',
  otherFamily: 'Une autre famille',
  addFamily: 'Ajouter une famille',
  invoice: 'Facture',
  invoiceHint: 'Facturer une famille',
  invoicePrompt: 'Pour quelle famille ?',
  payment: 'Paiement',
  paymentHint: 'Enregistrer un règlement',
  paymentPrompt: 'De quelle famille ?',
  exam: 'Examen',
  examHint: 'Composer un sujet',
  lastLesson: 'dernier cours',
  previousLesson: 'avant-dernier cours',
  lastPayment: 'dernier paiement reçu',
  unpaidLessons: 'cours impayés',
});
